<template>
  <div>
    <div class="k_time"><span>{{t1}}</span><span>{{t2}}</span></div>
    <div id="financing_chart"></div>
    <div class="k_time"><span>{{t3}}</span><span>{{t4}}</span></div>
    <div class="title">融资余额与融券余额差值</div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
    props:{
        node_list:{
            type:Array
        },
        sum_list:{
            type:Array
        },
        name:{
            type:String
        }
    },
    data(){
        return{
            t1:'单位:(亿元)',
            t2:'单位:(亿元)',
            t3:'',
            t4:'',
        }
    },
    watch:{
        node_list:{
            handler(v,ov){
                if(v){
                    this.financing_chart();
                }
            },
            deep:true,
        }
    },
    mounted(){
        this.financing_chart();
    },
    methods:{
        financing_chart(){
            var sum_list = this.sum_list;
            var node_list = this.node_list;

            function fontSize(res){
                let docEl = document.documentElement,
                    clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
                if (!clientWidth) return;
                let fontSize = (clientWidth / 750);
                return res*fontSize;

            }

            function split(list) {
                var time = [];
                var value = [];
                for(var i = 0;i<list.length;i++){
                    time.push(list[i].date);
                    value.push((list[i].dif/100000000).toFixed(2));
                }
                return {
                    time : time,
                    value : value,
                }
            }
            var sum = split(sum_list).value;
            var node = split(node_list).value;
            var time = split(sum_list).time;
            var max_sum = Math.ceil(Math.max(...sum));
            var min_sum = Math.floor(Math.min(...sum));
            var range_sum =Math.ceil(((max_sum-min_sum)/2));
            min_sum = max_sum - range_sum*2;
            //console.log(max_sum,min_sum,range_sum)

            var max_node = Math.ceil(Math.max(...node));
            var min_node = Math.floor(Math.min(...node));
            var range_node =Math.ceil(((max_node-min_node)/2));
            min_node = max_node - range_node*2;
            //console.log(max_node,min_node,range_node)

            this.t3 = time[0];
            this.t4 = time[time.length-1];

            var option = {
                grid:{
                    x:60,y:50,x2:100,y2:20
                },
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        lineStyle: {
                            color: 'transparent'	//显示竖线颜色
                        }
                    },
                    textStyle: {
                        color: '#333333',
                        fontSize:fontSize(22),
                    },
                    backgroundColor:'#FFFBFB',	//tooltip背景色
                    borderColor:'#FFA391',		//tooltip边框颜色
                    borderWidth:3,
                    formatter: function (param) {	//自定义tooltip内容
                        console.log(param)
                        var text = '';
                        text += '<div>' +
                            '<div>'+param[0].name+'</div>' +
                            '<div><span style="color:#448DFE">'+param[1].seriesName+'</span>'+param[1].data+'亿'+'</div>' +
                            '<div><span style="color:#FE484A">'+param[0].seriesName+'：</span>'+param[0].data+'亿'+'</div>' +
                            '</div>'
                        return text;
                    }
                },
                xAxis: {
                    type: 'category',
                    data:time,
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {    // 坐标轴 刻度
                        show: false,  // 是否显示
                    },
                },
                yAxis: [
                    {
                        // node
                        type: 'value',
                        min: min_node,
                        max: max_node,
                        interval: range_node,
                        axisLabel: {
                            formatter: '{value}',
                            textStyle: {
                                color: '#939393',//坐标值得具体的颜色
                                fontSize:fontSize(20),
                            },
                        },
                        //网格样式
                        splitLine: {
                            show: true,
                            lineStyle:{
                                color: ['#979797'],
                                width: 1.5,
                                type: 'dashed'
                            }
                        }
                    },
                    {
                        // sum
                        type: 'value',
                        min: 0,
                        max: 20000,
                        interval: 10000,
                        axisLabel: {
                            formatter: '{value}',
                            textStyle: {
                                color: '#939393',//坐标值得具体的颜色
                                fontSize:fontSize(20),
                            },
                        },
                        //网格样式
                        splitLine: {
                            show: true,
                            lineStyle:{
                                color: ['#979797'],
                                width: 1.5,
                                type: 'dashed'
                            }
                        }
                    },

                ],
                series: [
                    {
                        name: this.name,
                        data: node,
                        type: 'line',
                        smooth: true,
                        yAxisIndex: 0,
                        symbol:'circle',
                        showSymbol:false,
                        color: "#FE484A",//拐点样式
                        symbolSize:16,
                        itemStyle: {    // 图形的形状
                            normal: {
                                lineStyle:{
                                    opacity: 1,
                                    type:'solid'  //'dotted'虚线 'solid'实线
                                }
                            },
                            emphasis: {          //突出效果配置(鼠标置于拐点上时)
                                borderColor: '#fff',    //  拐点边框颜色
                                borderWidth: 2,         //  拐点边框宽度
                                shadowColor: '#FE484A', //  阴影颜色
                                shadowBlur: 10,          //  阴影渐变范围控制
                            },
                        },
                    },
                    {
                        name: '两市合计',
                        data: sum,
                        type: 'line',
                        smooth: true,
                        yAxisIndex: 1,
                        areaStyle: {
                            color: '#448DFE',
                            opacity: 0.1
                        },
                        symbol:'circle',
                        showSymbol:false,
                        color: "#448DFE",//拐点样式
                        symbolSize:16,
                        itemStyle: {    // 图形的形状
                            normal: {
                                lineStyle:{
                                    opacity: 1,
                                    type:'solid',  //'dotted'虚线 'solid'实线
                                }
                            },
                            emphasis: {          //突出效果配置(鼠标置于拐点上时)
                                borderColor: '#fff',    //  拐点边框颜色
                                borderWidth: 2,         //  拐点边框宽度
                                shadowColor: '#448DFE', //  阴影颜色
                                shadowBlur: 10,          //  阴影渐变范围控制
                            },
                        },
                    },


                ]
            };
            var myChart = echarts.init(document.getElementById('financing_chart'));
            myChart.setOption(option);
        },
    }
}
</script>

<style lang="scss">
  .k_time{
    font-size: 0.27rem;
    color: #939393;
    position: relative;
    line-height: 0.4rem;
    >span:nth-child(2){
      position: absolute;
      right: 0;
    }
  }
  .title{
    height: 0.53rem;
    font-size: 0.37rem;
    color: #939393;
    line-height: 0.53rem;
    margin-top: 0.2rem;
    text-align: center;
  }
</style>